var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "dice-launcher",
      class: { active: _vm.active },
      attrs: {
        type: "button",
        "aria-label": _vm.$t(_vm.active ? "Close" : "Open Tài Xỉu tables"),
        "aria-expanded": String(_vm.active),
      },
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c(
        "span",
        { staticClass: "dice-button", attrs: { "aria-hidden": "true" } },
        [
          _c("img", {
            staticClass: "dice-icon",
            attrs: {
              src: _vm.active
                ? require("@/assets/images/dice-icon-active.svg")
                : require("@/assets/images/dice-icon-default.svg"),
              alt: "",
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }